import React from 'react'

const NoRoles = () => {
  return <h3>No Role Access</h3>
}

export default NoRoles
